var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-data',_vm._b({on:{"input":function($event){return _vm.set($event)}}},'select-data',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }